<script>
    export let direction = "right";
</script>

<style>
    .left {
        transform: rotate(180deg);
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="inline-block w-6 h-6 ml-2 stroke-current {direction === "left" ? "left" : ""}">  
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>                        
</svg>